import { defineMessages } from 'react-intl';

export default defineMessages({
  markedAsShipped: {
    defaultMessage: 'Marked as Shipped',
    description: 'Text indicating that the current shipment was marked as shipped, instead of creating a label for it',
    id: 'WkeJ1r',
  },
  serviceAriaDescription: {
    defaultMessage: 'Service',
    description: 'Aria description for the service',
    id: 'uDZB8S',
  },
  trackingNumberAriaDescription: {
    defaultMessage: 'Open link to external tracking page',
    description: 'Aria description for the tracking number',
    id: '2yDBqd',
  },
  labelActionsDropdownMenuAriaLabel: {
    defaultMessage: 'Open label actions menu',
    description: 'Aria label for the label actions dropdown menu',
    id: 'pD5sR0',
  },
  copyTrackingNumberButtonLabel: {
    defaultMessage: 'Copy Tracking Number',
    description: 'Label for the copy tracking number button',
    id: 'm5GRDM',
  },
});
